module.exports = __webpack_public_path__ + "assets/images/01B-route-sheet.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/01B-route-sheet.png
// module id = 1251
// module chunks = 1